import styled from "styled-components";
import media from "styled-media-query";

export const SafeView = styled.div`
  display: flex;
  margin: 30px;
  padding-bottom: 50px;
  background-color: #fff;
`;

export const Container = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 10rem;
`;

export const ContainerItem = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: row;
`;

export const Item = styled.span`
  display: flex;
  width: 60%;
  height: 7vh;
  flex-direction: row;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0 10px 26px rgb(0 0 0 / 5%);
  position: relative;
  -webkit-transition: opacity 0.5s, -webkit-box-shadow 0.5s,
    -webkit-transform 0.5s;
  transition: opacity 0.5s, -webkit-box-shadow 0.5s, -webkit-transform 0.5s;
  transition: opacity 0.5s, box-shadow 0.5s, transform 0.5s;
  transition: opacity 0.5s, box-shadow 0.5s, transform 0.5s,
    -webkit-box-shadow 0.5s, -webkit-transform 0.5s;

  ${media.greaterThan("medium")`
width: 65%;
height: 100px;
`}

  &:hover {
    -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.1);
    -webkit-transform: translateY(-0.75rem);
    transform: translateY(-0.75rem);
  }
`;

export const ImageItem = styled.img`
  height: 40px;
  object-fit: contain;
  margin-left: 30px;
`;

export const TextItem = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 10px;
`;
export const Title = styled.span`
  font-size: 1.3rem;
  font-weight: bold;
`;
export const TextItemDesc = styled.span`
  font-size: 1.2rem;
  font-weight: 500;
  margin-left: 10px;
`;
